import { render, staticRenderFns } from "./unbekannteGeraete.vue?vue&type=template&id=2e24d075&scoped=true"
import script from "./unbekannteGeraete.vue?vue&type=script&lang=js"
export * from "./unbekannteGeraete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e24d075",
  null
  
)

export default component.exports